import React from 'react'

/* Styles */
import './Confrontation.css'

/* Modules */
import { Spin, Button, Tabs } from 'antd'
import { Link } from 'react-router-dom'

const ConfrontationView = (props) => {
	let roundOf32Confrontations = props.roundOf32Competitors.map((competitor, index) => {

		/* Change color if competitor wasn't fit */
		let localColor = ''
		if (!competitor.apto)
			localColor = 'red'

		/* Change width to remove scoreboard */
		let localWidth = '40%'
		if (!props.isScoreMan)
			localWidth = '50%'

		/* Check if it is necessary break line right after 2 competitors */
		if (index % 2 === 0) {
			return (
				<div key={index} className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
					<div style={{ float: 'left', width: '3%' }}>{index / 2 + 1}.</div>
					<div
						className='confrontationsLine02'
						style={{ color: localColor }}
					>
						{competitor.nome}&nbsp;
					</div>
					X
				</div>
			)
		} else {
			return (
				<div key={index}>
					<div className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
						<div
							className='confrontationsLine02'
							style={{ color: localColor }}
						>
							{competitor.nome}&nbsp;
						</div>
					</div>

					{props.isScoreMan ?
						<Link
							to={{
								pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
								state: {
									__key: props.champId,
									scoreboard: {
										"competitor01": {
											"nome": props.roundOf32Competitors[index - 1].nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": props.roundOf32Competitors[index - 1],
											"isInverted": false,
										},
										"competitor02": {
											"nome": competitor.nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": competitor
										},
										"stage": 'Fase 1',
										'realStage': 'roundOf32',
										'index': index - 1,
										'switchingOrRotation': 'switching',
										'idOfSwitching': props.switchingId,
									}
								}
							}}
						>
							<Button
								className='confrontationButton'
								type='primary'
								style={{ margin: '10px 0px' }}
							>Placar eletrônico</Button>
						</Link>
						:
						<span></span>
					}

					{props.isScoreMan ?
						<div className='confrontationButtonResponsive'>
							<Link
								to={{
									pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
									state: {
										__key: props.champId,
										scoreboard: {
											"competitor01": {
												"nome": props.roundOf32Competitors[index - 1].nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": props.roundOf32Competitors[index - 1],
												"isInverted": false,
											},
											"competitor02": {
												"nome": competitor.nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": competitor
											},
											"stage": 'Fase 1',
											'realStage': 'roundOf32',
											'index': index - 1,
											'switchingOrRotation': 'switching',
											'idOfSwitching': props.switchingId,
										}
									}
								}}
							>
								<i className="fas fa-calculator"></i>
							</Link>
						</div>
						:
						<span></span>
					}
					<div style={{ clear: 'both' }}></div>
				</div>
			)
		}

	})

	let roundOf16Confrontations = props.roundOf16Competitors.map((competitor, index) => {

		/* Change color if competitor wasn't fit */
		let localColor = ''
		if (!competitor.apto)
			localColor = 'red'

		/* Change width to remove scoreboard */
		let localWidth = '40%'
		if (!props.isScoreMan)
			localWidth = '50%'

		/* Check if it is necessary break line right after 2 competitors */
		if (index % 2 === 0) {
			return (
				<div key={index} className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
					<div style={{ float: 'left', width: '3%' }}>{index / 2 + 1}.</div>
					<div
						className='confrontationsLine02'
						style={{ color: localColor }}
					>
						{competitor.nome}&nbsp;
					</div>
					X
				</div>
			)
		} else {
			return (
				<div key={index}>
					<div className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
						<div
							className='confrontationsLine02'
							style={{ color: localColor }}
						>
							{competitor.nome}&nbsp;
						</div>
					</div>

					{props.isScoreMan ?
						<Link
							to={{
								pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
								state: {
									__key: props.champId,
									scoreboard: {
										"competitor01": {
											"nome": props.roundOf16Competitors[index - 1].nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": props.roundOf16Competitors[index - 1],
											"isInverted": false,
										},
										"competitor02": {
											"nome": competitor.nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": competitor
										},
										"stage": 'Oitavas de final',
										'realStage': 'roundOf16',
										'index': index - 1,
										'switchingOrRotation': 'switching',
										'idOfSwitching': props.switchingId,
									}
								}
							}}
						>
							<Button
								className='confrontationButton'
								type='primary'
								style={{ margin: '10px 0px' }}
							>Placar eletrônico</Button>
						</Link>
						:
						<span></span>
					}

					{props.isScoreMan ?
						<div className='confrontationButtonResponsive'>
							<Link
								to={{
									pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
									state: {
										__key: props.champId,
										scoreboard: {
											"competitor01": {
												"nome": props.roundOf16Competitors[index - 1].nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": props.roundOf16Competitors[index - 1],
												"isInverted": false,
											},
											"competitor02": {
												"nome": competitor.nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": competitor
											},
											"stage": 'Oitavas de final',
											'realStage': 'roundOf16',
											'index': index - 1,
											'switchingOrRotation': 'switching',
											'idOfSwitching': props.switchingId,
										}
									}
								}}
							>
								<i className="fas fa-calculator"></i>
							</Link>
						</div>
						:
						<span></span>
					}
					<div style={{ clear: 'both' }}></div>
				</div>
			)
		}

	})

	let quarterFinalsConfrontations = props.quarterFinalsCompetitors.map((competitor, index) => {

		/* Change color if competitor wasn't fit */
		let localColor = ''
		if (!competitor.apto)
			localColor = 'red'

		/* Change width to remove scoreboard */
		let localWidth = '40%'
		if (!props.isScoreMan)
			localWidth = '50%'

		/* Check if it is necessary break line right after 2 competitors */
		if (index % 2 === 0) {
			return (
				<div key={index} className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
					<div style={{ float: 'left', width: '3%' }}>{index / 2 + 1}.</div>
					<div
						className='confrontationsLine02'
						style={{ color: localColor }}
					>
						{competitor.nome}&nbsp;
					</div>
					X
				</div>
			)
		} else {
			return (
				<div key={index}>
					<div className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
						<div
							className='confrontationsLine02'
							style={{ color: localColor }}
						>
							{competitor.nome}&nbsp;
						</div>
					</div>

					{props.isScoreMan ?
						<Link
							to={{
								pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
								state: {
									__key: props.champId,
									scoreboard: {
										"competitor01": {
											"nome": props.quarterFinalsCompetitors[index - 1].nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": props.quarterFinalsCompetitors[index - 1],
											"isInverted": false,
										},
										"competitor02": {
											"nome": competitor.nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": competitor
										},
										"stage": 'Quartas de final',
										'realStage': 'quarterFinals',
										'index': index - 1,
										'switchingOrRotation': 'switching',
										'idOfSwitching': props.switchingId,
									}
								}
							}}
						>
							<Button
								className='confrontationButton'
								type='primary'
								style={{ margin: '10px 0px' }}
							>Placar eletrônico</Button>
						</Link>
						:
						<span></span>
					}

					{props.isScoreMan ?
						<div className='confrontationButtonResponsive'>
							<Link
								to={{
									pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
									state: {
										__key: props.champId,
										scoreboard: {
											"competitor01": {
												"nome": props.quarterFinalsCompetitors[index - 1].nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": props.quarterFinalsCompetitors[index - 1],
												"isInverted": false,
											},
											"competitor02": {
												"nome": competitor.nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": competitor
											},
											"stage": 'Quartas de final',
											'realStage': 'quarterFinals',
											'index': index - 1,
											'switchingOrRotation': 'switching',
											'idOfSwitching': props.switchingId,
										}
									}
								}}
							>
								<i className="fas fa-calculator"></i>
							</Link>
						</div>
						:
						<span></span>
					}
					<div style={{ clear: 'both' }}></div>
				</div>
			)
		}
	})

	let semiFinalsConfrontations = props.semiFinalsCompetitors.map((competitor, index) => {

		/* Change color if competitor wasn't fit */
		let localColor = ''
		if (!competitor.apto)
			localColor = 'red'

		/* Change width to remove scoreboard */
		let localWidth = '40%'
		if (!props.isScoreMan)
			localWidth = '50%'

		/* Check if it is necessary break line right after 2 competitors */
		if (index % 2 === 0) {
			return (
				<div key={index} className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
					<div style={{ float: 'left', width: '3%' }}>{index / 2 + 1}.</div>
					<div
						className='confrontationsLine02'
						style={{ color: localColor }}
					>
						{competitor.nome}&nbsp;
					</div>
					X
				</div>
			)
		} else {
			return (
				<div key={index}>
					<div className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
						<div
							className='confrontationsLine02'
							style={{ color: localColor }}
						>
							{competitor.nome}&nbsp;
						</div>
					</div>

					{props.isScoreMan ?
						<Link
							to={{
								pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
								state: {
									__key: props.champId,
									scoreboard: {
										"competitor01": {
											"nome": props.semiFinalsCompetitors[index - 1].nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": props.semiFinalsCompetitors[index - 1],
											"isInverted": false,
										},
										"competitor02": {
											"nome": competitor.nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": competitor
										},
										"stage": 'Semifinal',
										'realStage': 'semiFinals',
										'index': index - 1,
										'switchingOrRotation': 'switching',
										'idOfSwitching': props.switchingId,
									}
								}
							}}
						>
							<Button
								className='confrontationButton'
								type='primary'
								style={{ margin: '10px 0px' }}
							>Placar eletrônico</Button>
						</Link>
						:
						<span></span>
					}

					{props.isScoreMan ?
						<div className='confrontationButtonResponsive'>
							<Link
								to={{
									pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
									state: {
										__key: props.champId,
										scoreboard: {
											"competitor01": {
												"nome": props.semiFinalsCompetitors[index - 1].nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": props.semiFinalsCompetitors[index - 1],
												"isInverted": false,
											},
											"competitor02": {
												"nome": competitor.nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": competitor
											},
											"stage": 'Semifinal',
											'realStage': 'competitors',
											'index': index - 1,
											'switchingOrRotation': 'switching',
											'idOfSwitching': props.switchingId,
										}
									}
								}}
							>
								<i className="fas fa-calculator"></i>
							</Link>
						</div>
						:
						<span></span>
					}
					<div style={{ clear: 'both' }}></div>
				</div>
			)
		}
	})

	let finalConfrontations = props.finalCompetitors.map((competitor, index) => {

		/* Change color if competitor wasn't fit */
		let localColor = ''
		if (!competitor.apto)
			localColor = 'red'

		/* Change width to remove scoreboard */
		let localWidth = '40%'
		if (!props.isScoreMan)
			localWidth = '50%'

		/* Check if it is necessary break line right after 2 competitors */
		if (index % 2 === 0) {
			return (
				<div key={index} className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
					<div style={{ float: 'left', width: '3%' }}>{index / 2 + 1}.</div>
					<div
						className='confrontationsLine02'
						style={{ color: localColor }}
					>
						{competitor.nome}&nbsp;
					</div>
					X
				</div>
			)
		} else {
			return (
				<div key={index}>
					<div className='confrontationsLine01' id='confrontationsLine01' style={{ width: localWidth }}>
						<div
							className='confrontationsLine02'
							style={{ color: localColor }}
						>
							{competitor.nome}&nbsp;
						</div>
					</div>

					{props.isScoreMan ?
						<Link
							to={{
								pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
								state: {
									__key: props.champId,
									scoreboard: {
										"competitor01": {
											"nome": props.finalCompetitors[index - 1].nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": props.finalCompetitors[index - 1],
											"isInverted": false,
										},
										"competitor02": {
											"nome": competitor.nome,
											"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
											"allInfo": competitor
										},
										"stage": 'Final',
										'realStage': 'final',
										'index': index - 1,
										'switchingOrRotation': 'switching',
										'idOfSwitching': props.switchingId,
									}
								}
							}}
						>
							<Button
								className='confrontationButton'
								type='primary'
								style={{ margin: '10px 0px' }}
							>Placar eletrônico</Button>
						</Link>
						:
						<span></span>
					}

					{props.isScoreMan ?
						<div className='confrontationButtonResponsive'>
							<Link
								to={{
									pathname: '/home/champs/' + props.champId + '/confrontation/switching/scoreboard',
									state: {
										__key: props.champId,
										scoreboard: {
											"competitor01": {
												"nome": props.finalCompetitors[index - 1].nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": props.finalCompetitors[index - 1],
												"isInverted": false,
											},
											"competitor02": {
												"nome": competitor.nome,
												"pontuacao": { "1": 0, "2": 0, "3": 0, "4": 0, "punicoes": 0, "total": 0 },
												"allInfo": competitor
											},
											"stage": 'Final',
											'realStage': 'final',
											'index': index - 1,
											'switchingOrRotation': 'switching',
											'idOfSwitching': props.switchingId,
										}
									}
								}}
							>
								<i className="fas fa-calculator"></i>
							</Link>
						</div>
						:
						<span></span>
					}
					<div style={{ clear: 'both' }}></div>
				</div>
			)
		}
	})

	return (
		<div>
			{
				props.loadingConfrontations ?
					<Spin style={{ width: '100%', marginTop: '50px' }} /> :
					<div style={{ marginTop: '20px' }} id='champContent'>
						<div id='confrontationsBlockWithCompetitors'>
							<div className="confrontationTitle">
								<span style={{ color: 'gray', marginBottom: '20px', display: 'block', fontWeight: 'lighter', textAlign: 'center' }}>
									Sexo: {props.studentSexo} |&nbsp;
									Peso: {props.studentPeso} |&nbsp;
									Idade: {props.studentIdade}
								</span>

								<Tabs defaultActiveKey={props.showRoundOf32 ? 'item0' : 'item1'} centered>
									{
										props.showRoundOf32 ?
											<Tabs.TabPane key='item0' tab='Primeira fase'>
												<div id='roundOf32Block'>{roundOf32Confrontations}</div>
											</Tabs.TabPane>
											:
											null
									}

									<Tabs.TabPane key='item1' tab='Oitavas de final'>
										<div id='roundOf16Block'>{roundOf16Confrontations}</div>
									</Tabs.TabPane>

									<Tabs.TabPane key='item2' tab='Quartas de final'>
										<div id='quarterFinalsBlock'>{quarterFinalsConfrontations}</div>
									</Tabs.TabPane>

									<Tabs.TabPane key='item3' tab='Semifinal'>
										<div id='semiFinalsBlock'>{semiFinalsConfrontations}</div>
									</Tabs.TabPane>

									<Tabs.TabPane key='item4' tab='Final'>
										<div id='finalBlock'>{finalConfrontations}</div>
									</Tabs.TabPane>
								</Tabs>

								{/*
								<Menu mode='horizontal'>
									{
										props.showRoundOf32 ?
											<Menu.Item key='item0' style={{ width: '20%', textAlign: 'center' }} onClick={() => props.goToStage('roundOf32Block')}>Primeira fase</Menu.Item>
											:
											null
									}
									<Menu.Item key='item1' style={{ width: '20%', textAlign: 'center' }} className='sharedTextIntoDiv' onClick={() => props.goToStage('roundOf16Block')}>Oitavas de final</Menu.Item>
									<Menu.Item key='item2' style={{ width: '20%', textAlign: 'center' }} className='sharedTextIntoDiv' onClick={() => props.goToStage('quarterFinalsBlock')}>Quartas de final</Menu.Item>
									<Menu.Item key='item3' style={{ width: '20%', textAlign: 'center' }} className='sharedTextIntoDiv' onClick={() => props.goToStage('semiFinalsBlock')}>Semifinal</Menu.Item>
									<Menu.Item key='item4' style={{ width: '20%', textAlign: 'center' }} className='sharedTextIntoDiv' onClick={() => props.goToStage('finalBlock')}>Final</Menu.Item>
								</Menu>

								<div style={{ height: '20px' }}></div>

								<div id='roundOf32Block' style={{ display: props.showRoundOf32 ? 'block' : 'none' }}>{roundOf32Confrontations}</div>
								<div id='roundOf16Block' style={{ display: props.showRoundOf32 ? 'none' : 'block' }}>{roundOf16Confrontations}</div>
								<div id='quarterFinalsBlock' style={{ display: 'none' }}>{quarterFinalsConfrontations}</div>
								<div id='semiFinalsBlock' style={{ display: 'none' }}>{semiFinalsConfrontations}</div>
								<div id='finalBlock' style={{ display: 'none' }}>{finalConfrontations}</div>
								*/}
							</div>
						</div>
					</div>
			}
		</div>
	)
}

export default ConfrontationView